import type { WithActiveBranchId } from '@app/api/shared';

export enum BillsEndpoints {
  GetFilterData = 'GetFilterData',
  SearchBills = 'SearchBills',
  GetSearchResult = 'GetSearchResult',
  GetBillById = 'GetBillById',
  UpdateBill = 'UpdateBill',
  DeleteBill = 'DeleteBill',
  CreateThreeDsUrl = 'CreateThreeDsUrl',
}

export const BillsEndpointPaths: Record<BillsEndpoints, string> = {
  [BillsEndpoints.GetFilterData]: 'GetFilterData',
  [BillsEndpoints.SearchBills]: 'Search',
  [BillsEndpoints.GetSearchResult]: 'GetSearchResult',
  [BillsEndpoints.GetBillById]: 'GetById',
  [BillsEndpoints.UpdateBill]: 'Update',
  [BillsEndpoints.DeleteBill]: 'Delete',
  [BillsEndpoints.CreateThreeDsUrl]: 'CreateThreeDsUrl',
};

export interface ModelBillFilterData {
  DocumentTypes?: Record<string, string> | null;
  Statuses?: Record<string, string> | null;
  Organizations?: Record<string, string> | null;
}

export interface ModelUpdateBill {
  Id: number | null;
  Amount: number;
  Status: string | null;
  OrganizationId: number;
  DocumentType: string | null;
  Comment: string | null;
  Timestamp: string;
}

export interface ModelBill {
  Id: number;
  Number: string | null;
  DateCreated: string;
  Amount: number;
  Status: string | null;
  Organization: OrganizationModel;
  DocumentType: string | null;
  Comment: string | null;
  CanEdit: boolean;
}

export interface ModelBillSearchFilter {
  DateFrom: string | null;
  DateTo: string | null;
  OrganizationIds: number[] | null;
  DocumentTypes: string[] | null;
  Statuses: string[] | null;
  RecordsPerPage: number;
}

export interface ModelBillSearchResult {
  Id: number;
  Filter: ModelBillSearchFilter;
  Bills: ModelBillLite[] | null;
  PageN: number;
  CountPages: number;
  CountBills: number;
}

export interface ModelBillLite {
  Id: number;
  Name: string | null;
  Organization: OrganizationModel;
  DateCreated: string;
  Amount: number;
  Status: string | null;
}

export interface OrganizationModel {
  Key: number;
  Value: string | null;
}

export interface ModelYookassaPayment {
  PaymentId: number;
  ConfirmationUrl: string | null;
  PaymentUrlQR: string | null;
}

export interface ModelBillPaymentUrl {
  YookassaPayment: ModelYookassaPayment;
  Bill: ModelBill;
}

export interface SearchBillsRequest extends WithActiveBranchId {
  data: ModelBillSearchFilter;
}

export interface GetSearchResultRequest extends WithActiveBranchId {
  searchId: number;
  page: number;
  rowsPerPage: number;
}

export interface GetBillByIdRequest extends WithActiveBranchId {
  id: number;
}

export interface UpdateBillRequest extends WithActiveBranchId {
  data: ModelUpdateBill;
}

export interface DeleteBillRequest extends WithActiveBranchId {
  id: number;
}

export interface CreateThreeDsUrlRequest extends WithActiveBranchId {
  id: number;
  code?: string | null;
}

export type GetFilterDataRequest = WithActiveBranchId;

export type GetFilterDataResponse = ModelBillFilterData;
export type SearchBillsResponse = ModelBillSearchResult;
export type GetSearchResultResponse = ModelBillSearchResult;
export type GetBillByIdResponse = ModelBill;
export type UpdateBillResponse = ModelBill;
export type DeleteBillResponse = void;
export type CreateThreeDsUrlResponse = ModelBillPaymentUrl;
